import React, { useEffect, useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton";

const WaitingDisplay = ({
  title = "Créez votre premier dossier",
  subtitle = "Les dossiers sont le centre de votre activité sur hexagone !",
  goAction = () => {},
  actionText = "Nouveau Dossier",
}) => {
  return (
    <div className="relative justify-center items-center flex  w-fit   mt-10  p-0 bg-white  border-1 rounded-xl">
      {/* Your content */}

      <div className="relative bg-gradient-to-r from-wshadow_75 to-transparent p-4 rounded-xl z-10 flex flex-row items-start gap-10  ">
        <div className="relative  rounded-xl z-10 mr-48 flex flex-col gap-2  w-c300 ">
          <div className="text-h2 font-bold text-gray-800">{title}</div>{" "}
          <div className="text-h3 text-shadow_50">{subtitle}</div>
        </div>
        <div>
          <img
            src="https://i.ibb.co/TDvt5Xmk/Capture-d-cran-2025-03-23-184735.png"
            className="w-16 h-16 rounded-lg "
          ></img>
        </div>
      </div>
    </div>
  );
};

export default WaitingDisplay;
